exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._2fiV1jycmmHX8ApBknzZm1{padding:0 16px}._2w0KRNWc81YhaT5b8bla-t{font-size:14px;font-weight:400;color:\"[theme:themeDarkAlt, default:#005A9E]\";height:48px;overflow:hidden}html[dir] ._2w0KRNWc81YhaT5b8bla-t{padding:0}html[dir=ltr] ._2w0KRNWc81YhaT5b8bla-t{float:right}html[dir=rtl] ._2w0KRNWc81YhaT5b8bla-t{float:left}._2w0KRNWc81YhaT5b8bla-t:active,._2w0KRNWc81YhaT5b8bla-t:hover{color:\"[theme:themeDarkAlt, default:#005A9E]\"}", ""]);
// Exports
exports.locals = {
	"wrapper": "_2fiV1jycmmHX8ApBknzZm1",
	"linkButton": "_2w0KRNWc81YhaT5b8bla-t"
};